const HelperCommun = {
    cleanUrl: (...queryParams) => {
        const params = new URLSearchParams(window.location.search);
        const before = params.toString();

        queryParams.forEach((queryParam) => {
            params.delete(queryParam);
        });

        const after = params.toString();

        if (before === after) {
            return;
        }

        let to = window.location.pathname;
        if (after.length) {
            to += "?" + params.toString();
        }

        window.history.replaceState({}, document.title, to);
    },
};
HelperCommun.cleanUrl(
    "access_token",
    "access_expire",
    "refresh_token",
    "refresh_expire",
    "out",
    "token",
    "session",
);
